const getDefaultState = () => ({
  auth: {
    session: false,
    user: null,
    brands: null,
    products: null,
    suppliers: null,
  },
  twenty: {
    urls: {
      login: process.env.TWENTY_LOGIN_PAGE,
      api: process.env.TWENTY_API_URL,
      home: process.env.TWENTY_FRONT_PAGE,
      docs: process.env.TWENTY_DOCS_PAGE,
    },
  },
  domains: {
    loading: false,
    error: null,
    items: [],
  },
  loading: {
    state: false,
    error: false,
    steps: {
      total: 0,
      current: 0,
    },
    randomLoadingFacts: [
      'The longest recorded flight of a chicken is thirteen seconds.',
      'The average person walks the equivalent of three times around the world in a lifetime.',
      'The first alarm clock could only ring at 4am.',
      'The most popular first name in the world is Muhammad.',
      'The oldest known animal was a clam that lived to be 507 years old.',
      'The longest word in the English language is pneumonoultramicroscopicsilicovolcanoconiosis.',
      'The smallest bone in the human body is the stapes, located in the ear.',
      'The most common element in the universe is hydrogen.',
      'The fastest land animal is the cheetah, which can run up to 75 mph.',
      'The tallest mountain in the solar system is Olympus Mons on Mars.',
      'The deepest point in the ocean is the Mariana Trench, which is nearly 11km deep.',
      "The most abundant metal in the Earth's crust is aluminum.",
      'The hottest temperature ever recorded on Earth was 134°F in Death Valley, California.',
      'The coldest temperature ever recorded on Earth was -128.6°F in Antarctica.',
      'The longest river in the world is the Nile River, which is 6,853 km long.',
      'The largest lake in the world is the Caspian Sea, which covers an area of 371,000 sq km.',
      'The most spoken language in the world is Mandarin Chinese.',
      'The oldest living tree in the world is a bristlecone pine in California, estimated to be over 5,000 years old.',
      'The most visited city in the world is London, with over 19 million visitors per year.',
      'The highest waterfall in the world is Angel Falls in Venezuela, which is 3,212 feet tall.',
      "The most expensive painting ever sold was 'The Card Players' by Paul Cezanne, which sold for $250 million.",
      'The longest reigning monarch in history was Sobhuza II of Swaziland, who reigned for 82 years.',
      'The most powerful earthquake ever recorded was a magnitude 9.5 in Chile in 1960.',
      'The most dangerous animal in the world is the mosquito, which kills more than 1 million people each year.',
      'The most venomous snake in the world is the inland taipan, found in Australia.',
      'The oldest known living organism is a quaking aspen tree in Utah, estimated to be over 80,000 years old.',
      'The most visited website in the world is Google, with over 1 billion visitors per month.',
      'The most expensive book ever sold was a copy of the Gutenberg Bible, which sold for $4.9 million.',
      'The longest running TV show in the world is the Japanese show Sazae-san, which has been airing since 1969.',
      'The most populous country in the world is China, with over 1.4 billion people.',
      'The most expensive spice in the world is saffron, which can cost up to $11,000 per pound.',
      'The most active volcano in the world is Kilauea in Hawaii, which has been erupting continuously since 1983.',
      'The most expensive car ever sold was a 1962 Ferrari 250 GTO, which sold for $48.4 million.',
      'The most expensive coffee in the world is Kopi Luwak, which can cost up to $600 per pound.',
      'The most widely consumed beverage in the world is tea, with over 3 billion cups consumed daily.',
      'The most popular pet in the world is the domestic cat, with over 600 million cats worldwide.',
      "The most expensive diamond ever sold was the 'Pink Star', which sold for $71.2 million.",
      'The most powerful telescope in the world is the Hubble Space Telescope, which has been in orbit since 1990.',
      'The most visited museum in the world is the Louvre in Paris, with over 8 million visitors per year.',
      'The most expensive hotel in the world is the Burj Al Arab in Dubai, which costs up to $24,000 per night.',
      'The most powerful country in the world is the United States, with a GDP of over $20 trillion.',
      'The most popular sport in the world is soccer, with over 4 billion fans worldwide.',
      'The most visited website in the United States is Google, with over 200 million visitors per month.',
      'The most spoken language in the United States is English, with over 250 million speakers.',
      'The most populous city in the world is Tokyo, with over 37 million people.',
      'The most expensive perfume in the world is Clive Christian No.1, which costs up to $2,150 per ounce.',
      'The most expensive wine ever sold was a bottle of Chateau Lafite 1787, which sold for $156,450.',
      'The most widely used programming language in the world is Java, with over 9 million developers worldwide.',
      'The most expensive watch ever sold was a Patek Philippe Grandmaster Chime, which sold for $31 million.',
      'The most visited theme park in the world is Disneyland in California, with over 18 million visitors per year.',
      'The most expensive chocolate in the world is the To’ak Chocolate Bar, which costs up to $260 per bar.',
      'The most spoken language in Europe is Russian, with over 150 million speakers.',
      'The most populous city in the United States is New York City, with over 8.5 million people.',
      'The most expensive cheese in the world is pule, which can cost up to $600 per pound.',
      'The most powerful particle accelerator in the world is the Large Hadron Collider, located in Switzerland.',
      'The most expensive spice in India is saffron, which can cost up to $3,000 per pound.',
      'The most visited website in China is Baidu, with over 600 million visitors per month.',
      'The most powerful telescope on Earth is the Gran Telescopio Canarias, located in Spain.',
      'The most expensive coffee in the world is Kopi Luwak, which can cost up to $600 per pound.',
      'The most dangerous animal in Africa is the hippopotamus, which kills more than 500 people each year.',
      'The most expensive book ever sold was a copy of the Gutenberg Bible, which sold for $4.9 million.',
      'The longest running TV show in the United States is The Simpsons, which has been airing since 1989.',
      'The most populous country in Europe is Russia, with over 144 million people.',
      "The most expensive diamond ever sold was the 'Pink Star', which sold for $71.2 million.",
      'The most powerful earthquake ever recorded was a magnitude 9.5 in Chile in 1960.',
      'The most venomous snake in the world is the inland taipan, found in Australia.',
      'The oldest known living organism is a quaking aspen tree in Utah, estimated to be over 80,000 years old.',
      'The most active volcano in the world is Kilauea in Hawaii, which has been erupting continuously since 1983.',
      'The most expensive car ever sold was a 1962 Ferrari 250 GTO, which sold for $48.4 million.',
      'The most widely consumed beverage in the world is tea, with over 3 billion cups consumed daily.',
      'The most popular pet in the world is the domestic cat, with over 600 million cats worldwide',
    ],
    randomErrorMessages: [
      'Tubular weirdness detected',
      'Disaster in the mainframe - run for your lives!',
      'System has experienced a bamboozling error',
      'Unicorns and rainbows have caused a catastrophic failure!',
      'Error 007: Leaping Llama Detected',
      'Operation failed due to naughty pixels',
      'Objects in mirror are closer than they appear',
      'Too much cheese on board!',
      'Server not ready. Please try again later.',
      "Can't find my 'any' key",
    ],
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/app/defaultState.js